import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/empty.png'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-inner page-left" }
const _hoisted_3 = { class: "paper-tabs" }
const _hoisted_4 = { class: "el-dropdown-link" }
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = { class: "el-dropdown-link" }
const _hoisted_7 = { class: "el-dropdown-link" }
const _hoisted_8 = { class: "paper-inner" }
const _hoisted_9 = {
  key: 0,
  class: "page-inner-box empty"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "title1" }
const _hoisted_12 = { class: "paper-inner-item-title" }
const _hoisted_13 = { style: {"text-align":"center"} }
const _hoisted_14 = { class: "page-inner page-right" }
const _hoisted_15 = { class: "page-box-title2 title1" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  style: {"margin-top":"10px"}
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "page-inner-box page-inner-right-box"
}
const _hoisted_20 = {
  key: 0,
  class: ""
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = {
  key: 1,
  class: ""
}
const _hoisted_23 = { class: "" }
const _hoisted_24 = {
  key: 0,
  class: "correctTitle3"
}
const _hoisted_25 = {
  key: 1,
  class: "correctTitle3"
}
const _hoisted_26 = {
  key: 2,
  class: "correctTitle3"
}
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 0,
  class: "correctTitle3"
}
const _hoisted_29 = {
  key: 1,
  class: "correctTitle3"
}
const _hoisted_30 = {
  key: 2,
  class: "correctTitle3"
}
const _hoisted_31 = {
  key: 3,
  class: "correctTitle3"
}
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 0,
  class: "correctTitle3"
}
const _hoisted_34 = {
  key: 1,
  class: "correctTitle3"
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 2,
  class: ""
}
const _hoisted_37 = { key: 3 }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 4,
  class: "page-inner-box empty page-inner-right-box"
}

import { ref, reactive, onMounted, nextTick } from 'vue';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { provinceList } from "@/utils/city.js"
import { getExam, getExamGuide, getExamDetail } from "@/api/composition.js"
import { getDict } from "@/api/common.js"
import { ElLoading } from 'element-plus'
import { useRouter } from 'vue-router';
import { useStore } from "vuex"

export default /*@__PURE__*/_defineComponent({
  __name: 'pastExamPaper',
  setup(__props) {

const router = useRouter()
const store = useStore();
const userInfo = ref(store.state.userInfo)
const examColumns = ref(['全部'])
const examInfo = ref('')
const provinceInfo = ref({})
const provinceArr = [{
    label: '全部',
    value: '全部'
}, ...provinceList]
const cityList = ref([])
const cityInfo = ref({})
let yearColumns = ['全部']
const yearInfo = ref('')
const examUrl = ref('')
const showPreview = ref(false)
const aiMessage = ref('')
const artiExamTitle = ref('')
let resultInfo = ref({})
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
let year = new Date().getFullYear(), n = 0;
while (n <= 10) {
    yearColumns.push(year - n);
    n++;
}
const tableList = ref([] as any)
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 0
})
const pageShow = ref(true)
function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}
function provinceCommand(item) {
    if (provinceInfo.value.value == item.value) return;
    if (item.label == '全部') {
        provinceInfo.value = {
            label: '省份',
            value: ''
        }
        cityInfo.value = {}
        cityList.value = []
    } else {
        provinceInfo.value = item;
        cityInfo.value = {}
        if (item.children.length == 1) {
            cityList.value = item.children
        } else {
            cityList.value = [{
                label: '全部',
                value: '全部'
            }, ...item.children]
        }
    }
    handleCurrentChange(1)
}
function cityCommand(item) {
    if (cityInfo.value.value == item.value) return;
    if (item.label == '全部') {
        cityInfo.value = {
            label: '城市',
            value: ''
        }
    } else {
        cityInfo.value = item;
    }
    handleCurrentChange(1)
}
function yearCommand(item) {
    if (yearInfo.value == item) return;
    if (item == '全部') {
        yearInfo.value = '年份';
    } else {
        yearInfo.value = item;
    }
    handleCurrentChange(1)
}
function examCommand(item) {
    if (examInfo.value == item) return;
    if (item == '全部') {
        examInfo.value = '作文类型';
    } else {
        examInfo.value = item;
    }
    handleCurrentChange(1)
}

function getList(cb) {
    let params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size
    }
    if (!provinceInfo.value.label || provinceInfo.value.label == '省份') {
        params.artiExamProvince = ''
    } else {
        params.artiExamProvince = provinceInfo.value.label
    }
    if (!cityInfo.value.label || cityInfo.value.label == '城市') {
        params.artiExamCity = ''
    } else {
        params.artiExamCity = cityInfo.value.label
    }
    if (!yearInfo.value || yearInfo.value == '年份') {
        params.artiExamYear = ''
    } else {
        params.artiExamYear = yearInfo.value
    }
    if (!examInfo.value || examInfo.value == '作文类型') {
        params.artiExamType = ''
    } else {
        params.artiExamType = examInfo.value
    }
    getExam(params).then(res => {
        tableList.value = res.data.records || []
        pageInfo.value.total = res.data.total || 0;
        cb && cb()
    })
}

function toGuide(item) {
    const loadingInstance = ElLoading.service()
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    aiMessage.value = ''
    getExamDetail(item.artiExamId).then(res => {
        const { artiExamFileUrlList = [] } = res.data;
        examUrl.value = artiExamFileUrlList && artiExamFileUrlList.length > 0 ? artiExamFileUrlList[0] : '';
        artiExamTitle.value = item.artiExamTitle
        getExamGuide(item.artiExamId).then(res => {
            if (res.data.artiExamGuidanceResult) {
                const matches = res.data.artiExamGuidanceResult.match(regex) || [];
                let resultArr = matches.filter(match => match !== '');
                resultArr.forEach(info => {
                    if (romanNumerals.includes(info)) {
                        if (info in resultNum) {
                            resultNum[info] = resultNum[info] + 1;
                            resultInfo.value[info].push('');
                        } else {
                            resultNum[info] = 1;
                            resultInfo.value[info] = [''];
                        }
                        currentKey = info;
                    } else if (currentKey in resultInfo.value) {
                        if (resultNum[currentKey] == 1) {
                            resultInfo.value[currentKey][resultNum[
                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                        } else {
                            resultInfo.value[currentKey][resultNum[
                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                        }

                    }
                })
                aiMessage.value = res.data.artiExamGuidanceResult
            }
        }).finally(() => {
            loadingInstance.close()
        })
    }).catch(() => {
        loadingInstance.close()
    })

}

function toCorrect() {
    if (!userInfo.value.userId) {
        store.dispatch('setLoginFlag')
    } else {
        router.push('/composition/correct?page=pastExamPaper')
    }

}

function getDictList() {
    getDict({
        dicCode: 'dd_arti_type'
    }).then(res => {
        examColumns.value = ['全部',
            ...(res.data || []).map(item => {
                return item.dicItemName
            })
        ]
    })
}

onMounted(() => {
    getList(() => {
        toGuide(tableList.value[0])
    })
    getDictList()
})

return (_ctx: any,_cache: any) => {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "paper-title" }, "历年作文真题解析", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, {
          gutter: 20,
          justify: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, {
                  "max-height": "350px",
                  onCommand: provinceCommand
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(provinceArr, (item) => {
                          return _createVNode(_component_el_dropdown_item, {
                            key: item.value,
                            command: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"])
                        }), 64))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, [
                      _createTextVNode(_toDisplayString(provinceInfo.value.label || '省份') + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, {
                  "max-height": "350px",
                  onCommand: cityCommand,
                  disabled: !cityList.value.length
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: item.value,
                            command: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, [
                      _createTextVNode(_toDisplayString(cityInfo.value.label || '城市') + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, {
                  "max-height": "350px",
                  onCommand: yearCommand
                }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(yearColumns), (item) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: item,
                            command: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, [
                      _createTextVNode(_toDisplayString(yearInfo.value || '年份') + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown, { onCommand: examCommand }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examColumns.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: item,
                            command: item
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item), 1)
                            ]),
                            _: 2
                          }, 1032, ["command"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, [
                      _createTextVNode(_toDisplayString(examInfo.value || '作文类型') + " ", 1),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_down)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        (!tableList.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[4] || (_cache[4] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1),
              _createElementVNode("div", null, "暂无数据", -1)
            ])))
          : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "paper-inner-item"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item.artiExamType) + " | 查阅：" + _toDisplayString(item.artiExamVisitNum), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_button, {
                      color: "#ef8b25",
                      plain: "",
                      size: "small",
                      onClick: _withModifiers(($event: any) => (toGuide(item)), ["stop"])
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode("作文指导")
                      ])),
                      _: 2,
                      __: [5]
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        (pageShow.value)
          ? (_openBlock(), _createBlock(_component_el_config_provider, {
              key: 0,
              locale: _unref(zhCn)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_pagination, {
                  "current-page": pageInfo.value.current,
                  "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageInfo.value.current) = $event)),
                  "page-size": pageInfo.value.size,
                  "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageInfo.value.size) = $event)),
                  total: pageInfo.value.total,
                  "page-sizes": [10, 20, 30, 50],
                  layout: "total, sizes,jumper",
                  onSizeChange: handleSizeChange,
                  onCurrentChange: handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total"])
              ]),
              _: 1
            }, 8, ["locale"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[8] || (_cache[8] = _createElementVNode("span", null, "历年作文真题解析", -1)),
        _withDirectives(_createVNode(_component_el_button, {
          style: {"float":"right"},
          color: "#ef8b25",
          class: "footer-btn1",
          onClick: toCorrect
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("批改我的作文")
          ])),
          _: 1,
          __: [7]
        }, 512), [
          [_vShow, aiMessage.value]
        ])
      ]),
      (artiExamTitle.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: artiExamTitle.value,
            style: {"margin-top":"10px"}
          }, null, 8, _hoisted_16))
        : _createCommentVNode("", true),
      (examUrl.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("img", {
              src: examUrl.value,
              class: "upload-img",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPreview.value=true))
            }, null, 8, _hoisted_18)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_divider, null, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createElementVNode("span", { style: {"color":"#333","font-size":"16px"} }, "三步九法作文指导", -1)
        ])),
        _: 1,
        __: [9]
      }),
      (Object.keys(_unref(resultInfo)).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            (_unref(resultInfo).Ⅱ && _unref(resultInfo).Ⅱ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "correctTitle" }, " 作文题目解析： ", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅱ, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: index
                    }, [
                      _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_21)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅲ && _unref(resultInfo).Ⅲ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[11] || (_cache[11] = [
                  _createElementVNode("div", { class: "correctTitle" }, " 作文题目指导： ", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              (_unref(resultInfo).Ⅲ && _unref(resultInfo).Ⅲ.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "correctTitle2" }, "【放】", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅲ, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "",
                        key: 'f'+index
                      }, [
                        (index==0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, "多头放想"))
                          : _createCommentVNode("", true),
                        (index==4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, "多向放想"))
                          : _createCommentVNode("", true),
                        (index==8)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, "多见放想"))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_27)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(resultInfo).Ⅳ && _unref(resultInfo).Ⅳ.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "correctTitle2" }, "【悟】", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅳ, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "",
                        key: 'w'+index
                      }, [
                        (index==0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, "触发悟道"))
                          : _createCommentVNode("", true),
                        (index==3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, "推导悟道"))
                          : _createCommentVNode("", true),
                        (index==8)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, "升维悟道"))
                          : _createCommentVNode("", true),
                        (index==12)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, "守正悟道"))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_32)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(resultInfo).Ⅴ && _unref(resultInfo).Ⅴ.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "correctTitle2" }, "【收】", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅴ, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "",
                        key: 's'+index
                      }, [
                        (index==0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, "打包"))
                          : _createCommentVNode("", true),
                        (index==2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, "整合"))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_35)
                      ]))
                    }), 128))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            (_unref(resultInfo).Ⅶ && _unref(resultInfo).Ⅶ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[15] || (_cache[15] = [
                  _createElementVNode("div", { class: "correctTitle" }, " 总结： ", -1)
                ])))
              : _createCommentVNode("", true),
            (_unref(resultInfo).Ⅶ && _unref(resultInfo).Ⅶ.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resultInfo).Ⅶ, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "",
                      key: 'z'+index
                    }, [
                      _createElementVNode("div", { innerHTML: item }, null, 8, _hoisted_38)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!Object.keys(_unref(resultInfo)).length && aiMessage.value && aiMessage.value!='{}')
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            innerHTML: aiMessage.value,
            class: "page-inner-box page-inner-right-box"
          }, null, 8, _hoisted_39))
        : _createCommentVNode("", true),
      (!Object.keys(_unref(resultInfo)).length && !aiMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[16] || (_cache[16] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1),
            _createElementVNode("div", null, "结果将在此处展示！", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    (showPreview.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": examUrl.value?[examUrl.value]:[],
          "show-progress": "",
          "initial-index": 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showPreview.value = false))
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ]))
}
}

})